import axios from 'axios'
import {getAllApplicants, getAllApplicantsByBatch} from "@/services/ApiServices";

const state = {
    allApplicants: [],
    serverApplicants: [],
    isLoading: true,
    applicantEmail: '',
    headers: [
        {
            text: 'First Name',
            align: 'start',
            value: 'firstName',
        },
        {text: 'Last Name', value: 'lastName'},
        {text: 'State of Origin', value: 'stateOfOrigin'},
        {text: 'Gender', value: 'gender'},
        {text: 'Age', value: 'age'},
        {text: 'App. Status', value: 'applicationStatus'},
        {text: 'Test Score', value: 'testScore'},
        {text: 'Region', value: 'region'},
        {text: 'Batch', value: 'batchId'},
    ],
    currentTableState: {
        currentList: 'allApplicants',
        search: '',
        itemsPerPage: 30,
    },
    listStatus: {
        allApplicants: true,
        interviewScheduled: false,
        interviewing: false,
        interviewed: false,
        awaitingInterview: false,
        enrolled: false,
        offeredAdmission: false,
    },
    currentChecks: [],
    filterConditions: {
        "State of Origin": {
            label: "stateOfOrigin",
            option: [],
        },
        "Age Range": {
            label: "ageRange",
            option: [],
        },
        "Gender": {
            label: "gender",
            option: [],
        },
        "Grade": {
            label: "grade",
            option: [],
        },
        "Test Score": {
            label: "testScore",
            option: [],
        },
        "Willing to relocate": {
            label: "willingToRelocate",
            option: [],
        },
        "Marital Status": {
            label: "maritalStatus",
            option: [],
        },
        "Highest Level": {
            label: "highestLevel",
            option: [],
        },
        "Region": {
            label: "region",
            option: [],
        },
        "Cohort": {
            label: "cohortAssignedTo",
            option: [],
        },
        "Batch": {
            label: "batchId",
            option: [],
        },
    },
}
const getters = {
    allApplicants: state => state.allApplicants,
    isLoading: state => state.isLoading,
    applicantEmail: state => state.applicantEmail,
    headers: state => state.headers,
    currentTableState: state => state.currentTableState,
    listStatus: state => state.listStatus,
    currentChecks: state => state.currentChecks,
    filterConditions: state => state.filterConditions,
}
const actions = {

    async fetchAllApplicants({commit}) {

        const role = JSON.parse(sessionStorage.getItem('userRole'));
        const headers = JSON.parse(sessionStorage.getItem('headers'));
        let apiToCall =  getAllApplicants();
        const batchId = JSON.parse(sessionStorage.getItem('userBatchId'));
        apiToCall = role === "SPONSOR"? getAllApplicantsByBatch(batchId): getAllApplicants();

        console.log("API is "+ apiToCall);
        await axios(apiToCall, {headers: headers})
            .then(res => {
                commit('setIsLoading')
                console.log(res.data)
                commit('setServerApplicants', res.data)
                if (state.currentTableState.currentList === 'allApplicants') {
                    commit('setDisplayList', 'allApplicants')
                } else commit('setDisplayList', state.currentTableState.currentList)
                commit('filterApplicants')
            })
            .catch(err => console.log(err, 'err printed...'))
    },
    setAllApplicants({commit}, applicants) {
        commit('setAllApplicants', applicants)
    },
    setApplicantEmail({commit}, applicant) {
        commit('setApplicantEmail', applicant.id)
    },
    setDisplayList({commit}, displayOption) {
        commit('setDisplayList', displayOption)
        // commit('filterApplicants', state.filterConditions)
    },
    setCurrentTableState({commit}, keyValue) {
        commit('setCurrentTableState', keyValue)
    },
    filterApplicants({commit}) {
        commit('filterApplicants')
    },
    pushToCurrentChecks({commit}, payload) {
        commit('pushToCurrentChecks', payload)
    },
    removeFromCurrentChecks({commit}, payload) {
        commit('removeFromCurrentChecks', payload)
    },
    clearCurrentChecks({commit}) {
        commit('clearCurrentChecks')
    },
    setFilterConditionsWithOption({commit}, payload) {
        commit('setFilterConditionsWithOption', payload)
    },
}
const mutations = {
    setAllApplicants: state => state.allApplicants = state.serverApplicants,
    setServerApplicants: (state, serverApplicants) => state.serverApplicants = processApplicants(serverApplicants),
    setApplicantEmail: (state, applicantEmail) => state.applicantEmail = applicantEmail,
    setIsLoading: state => state.isLoading = false,
    setDisplayList: (state, displayOption) => {
        state.allApplicants = setDisplayLists(state, displayOption)
        state.allApplicants = filter(state)
    },
    setCurrentTableState: (state, keyValue) => state.currentTableState[keyValue.key] = keyValue.value,
    filterApplicants: (state) => state.allApplicants = filter(state),
    pushToCurrentChecks: (state, payload) => {
        const checksArray = state.currentChecks
        checksArray.push(payload)
        state.currentChecks = checksArray
    },
    removeFromCurrentChecks: (state, payload) => {
        state.currentChecks = state.currentChecks.filter(check => check !== payload)
    },
    clearCurrentChecks: (state) => {
        state.currentChecks = []
    },
    setFilterConditionsWithOption: (state, payload) => {
        if (payload.action === 'push')
            state.filterConditions[payload.label].option.push(payload.options)
        else if (payload.action === 'remove') {
            console.log(payload)
            state.filterConditions[payload.label].option = state.filterConditions[payload.label].option
                .filter(option => option !== payload.options)
        }
        else state.filterConditions[payload.label].option = []
    },
}

function filter(state) {
    const {filterConditions} = state
    let myAllApplicants = setDisplayLists(state, state.currentTableState.currentList)
    state.currentChecks.map(label => {
        if (filterConditions[label].option.length > 1) {
            // console.log(filterConditions[label].option)
            if (myAllApplicants.length === state.allApplicants.length) {
                // console.log('i have same length', myAllApplicants, state.allApplicants)
                myAllApplicants =[]
                filterConditions[label].option.map(option => {
                    state.allApplicants
                        .filter(applicant => applicant[filterConditions[label].label] === option)
                        .map(applicant => myAllApplicants.push(applicant))
                })
            } else {
                const doubleFilterContainer = []
                filterConditions[label].option.map(option => {
                    myAllApplicants.filter(applicant => applicant[filterConditions[label].label] === option)
                        .map(applicant => doubleFilterContainer.push(applicant))
                })
                myAllApplicants = doubleFilterContainer
            }
        } else {
            myAllApplicants = myAllApplicants.filter(applicant => applicant[filterConditions[label].label] === filterConditions[label].option[0])
            // console.log(myAllApplicants)
        }
    })
    return myAllApplicants
}

const setHeaders = (state, headers) => state.headers = headers

const setDisplayLists = (state, displayOption) => {
    Object.keys(state.listStatus).map(status => state.listStatus[status] = false)
    if (displayOption === 'allApplicants') {
        state.listStatus[displayOption] = true
        setHeaders(state, defaultHeader)
        return state.serverApplicants
    }

    if (displayOption === 'interviewScheduled') {
        state.listStatus[displayOption] = true
        setHeaders(state, interviewScheduledHeader)
        return state.serverApplicants.filter(applicant => (applicant.applicationStatus === 'Invited For Interview') ||
            (applicant.applicationStatus === 'Accepted Interview'))
    }

    if (displayOption === 'interviewing') {
        state.listStatus[displayOption] = true
        setHeaders(state, interviewingHeader)
        return state.serverApplicants.filter(applicant => applicant.applicationStatus === 'Interviewing')
    }
    if (displayOption === 'interviewed') {
        state.listStatus[displayOption] = true
        setHeaders(state, interviewedHeader)
        return state.serverApplicants.filter(applicant => (applicant.applicationStatus === 'Interviewed') ||
            (applicant.applicationStatus === 'Offered Admission') || (applicant.applicationStatus === 'Declined Admission') || (applicant.applicationStatus === 'Application Declined'))
    }
    if (displayOption === 'awaitingInterview') {
        state.listStatus[displayOption] = true
        setHeaders(state, defaultHeader)
        return state.serverApplicants.filter(applicant => applicant.applicationStatus === 'Tested')
    }
    if (displayOption === 'offeredAdmission') {
        state.listStatus[displayOption] = true
        setHeaders(state, offeredAdmissionHeader)
        return state.serverApplicants.filter(applicant => (applicant.applicationStatus === 'Offered Admission') ||
            (applicant.applicationStatus === 'Accepted Admission') || (applicant.applicationStatus === 'Rejected Admission'))
    }
    if (displayOption === 'enrolled') {
        state.listStatus[displayOption] = true
        setHeaders(state, enrolledHeader)
        return state.serverApplicants.filter(applicant => applicant.applicationStatus === 'Enrolled')
    }

    if (displayOption === 'checkedIn') {
        state.listStatus[displayOption] = true
        setHeaders(state, checkedInHeader)
        return state.serverApplicants.filter(applicant => applicant.applicationStatus === 'Checked In' || applicant.applicationStatus === 'Native')
    }

    if (displayOption === 'nonResponsive') {
        state.listStatus[displayOption] = true
        setHeaders(state, defaultHeader)
        return state.serverApplicants.filter(applicant => applicant.applicationStatus === 'Non Responsive' || applicant.applicationStatus === 'Application Withdrawn')
    }
}


const processApplicants = (applicants) => Object.keys(applicants).map(applicant => (applicants[applicant]))


//Headers
const offeredAdmissionHeader = [
    {text: 'First Name', align: 'start', value: 'firstName',},
    {text: 'Last Name', value: 'lastName'},
    {text: 'State of Origin', value: 'stateOfOrigin'},
    {text: 'Gender', value: 'gender'},
    {text: 'Age', value: 'age'},
    {text: 'App. Status', value: 'applicationStatus'},
    {text: 'Cohort Assigned', value: 'cohortAssignedTo'},
    {text: 'Amount paid', value: 'amountPaid'},

]
const interviewedHeader = [
    {text: 'First Name', align: 'start', value: 'firstName',},
    {text: 'Last Name', value: 'lastName'},
    {text: 'Gender', value: 'gender'},
    {text: 'Region', value: 'region'},
    {text: 'Recommendation', value: 'interviewerRecommendation'},
    {text: 'Decision', value: 'finalApplicationDecision'},
    {text: 'App. Status', value: 'applicationStatus'},
]
const interviewScheduledHeader = [
    {text: 'First Name', align: 'start', value: 'firstName',},
    {text: 'Last Name', value: 'lastName'},
    {text: 'Phone Number', value: 'phoneNumber'},
    {text: 'Gender', value: 'gender'},
    {text: 'Date & Time', value: 'interviewDateTime'},
    {text: 'Invited by', value: 'invitedBy'},
    {text: 'App. Status', value: 'applicationStatus'},

]
const interviewingHeader = [
    {text: 'First Name', align: 'start', value: 'firstName',},
    {text: 'Last Name', value: 'lastName'},
    {text: 'Phone Number', value: 'phoneNumber'},
    {text: 'Gender', value: 'gender'},
    {text: 'Date & Time', value: 'interviewDateTime'},
    {text: 'Interviewer', value: 'interviewer'},
]

const defaultHeader = [
    { text: 'First Name', align: 'start', value: 'firstName',},
    {text: 'Last Name', value: 'lastName'},
    {text: 'State of Origin', value: 'stateOfOrigin'},
    {text: 'Gender', value: 'gender'},
    {text: 'Age', value: 'age'},
    {text: 'App. Status', value: 'applicationStatus'},
    {text: 'Test Score', value: 'testScore'},
    {text: 'Region', value: 'region'},
    {text: 'Date Applied', value: 'dateApplied'},
    {text: 'Batch', value: 'batchId'},
]
const enrolledHeader = [
    {
        text: 'First Name',
        align: 'start',
        value: 'firstName',
    },
    {text: 'Last Name', value: 'lastName'},
    {text: 'State of Origin', value: 'stateOfOrigin'},
    {text: 'Gender', value: 'gender'},
    {text: 'Age', value: 'age'},
    {text: 'Enrollment Status', value: 'nativeState'},
    {text: 'Amount paid', value: 'amountPaid'}
]

const checkedInHeader = [
    {
        text: 'First Name',
        align: 'start',
        value: 'firstName',
    },
    {text: 'Last Name', value: 'lastName'},
    {text: 'State of Origin', value: 'stateOfOrigin'},
    {text: 'Gender', value: 'gender'},
    // {text: 'Age', value: 'age'},
    {text: 'DOB', value: 'dob'},

    {text: 'Enrollment Status', value: 'nativeState'},
    {text: 'Amount paid', value: 'amountPaid'},
    {text: 'SCV ID', value: 'scvid'}
]


export default {
    state,
    getters,
    actions,
    mutations
}